<template>
  <img v-if="iconType === 'img' || name?.split('.')[1]" class="w-5 h-5" :src="imgSrc" alt="" loading="lazy" @error="onImgError"/>
  <NuxtIcon v-else-if="iconType === 'svg'" class="!svg:(h-full mb-0) flex" :name="name" :filled="filled"/>
  <Icon v-else class="text-2xl" :name="name"/>
</template>


<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  iconType: {
    type: String,
    default: 'icon'
  },
  filled: {
    type: Boolean,
    default: true
  }
})

const config = useRuntimeConfig()
const apiBase = config.public.nodeEnv === 'production'
  ? config.public.apiUrlProd
  : config.public.apiUrlDev

// Fallback image shown whenever the resolved image URL fails to load
// (e.g. the file manager / S3 service is down). Never render the raw
// URL/alt text on the page.
const fallbackSrc = '/images/noProfile.png'
const hasError = ref(false)

const resolvedSrc = computed(() => {
  if (!props.name) return fallbackSrc
  if (props.name.includes('http')) return props.name
  if (props.name.startsWith('/')) return apiBase + props.name
  return '/images/' + props.name
})

// Reset error state whenever the source name changes so a new image gets a fresh chance to load.
watch(() => props.name, () => {
  hasError.value = false
})

const imgSrc = computed(() => (hasError.value ? fallbackSrc : resolvedSrc.value))

const onImgError = () => {
  // Avoid infinite loop if the fallback itself ever fails to load.
  if (!hasError.value && imgSrc.value !== fallbackSrc) {
    hasError.value = true
  }
}
</script>
